(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1786],{

/***/ 19573:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/caterers/[city]/[caterer]",
      function () {
        return __webpack_require__(50033);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WU": function() { return /* binding */ PLZ_REGEX; },
/* harmony export */   "d0": function() { return /* binding */ PHONE_NUMBER_REGEX; },
/* harmony export */   "f": function() { return /* binding */ CUSTOMER_LEAD_RECORD_TYPE; },
/* harmony export */   "z3": function() { return /* binding */ GET_POSTCODE_REGEXP; }
/* harmony export */ });
/* unused harmony export DEFAULT_CITY */
var PHONE_NUMBER_REGEX = /\b[+]?[(]?[0-9]{2,6}[)]?[-\s.]?[-\s/.0-9]{3,15}\b/;
var PLZ_REGEX = /[A-Z0-9 -]{3,}/;
var CUSTOMER_LEAD_RECORD_TYPE = "01258000000DWRx";
var DEFAULT_CITY = "berlin";
var GET_POSTCODE_REGEXP = /[\d]+[A-Z]*/g;


/***/ }),

/***/ 89329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ webToLeadData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);




var webToLeadData = function(values) {
    var _obj;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.oid, "00D58000000ZImI"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.lead_source, "heycater.com Web2Lead form"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.entrance_url, js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get("entrance_url")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.referrer_url, js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get("referrer_url")), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, salesforceFieldMapping.conversion_url, window.location.href), _obj), Object.keys(values).reduce(function(accumulator, key) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, accumulator), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, salesforceFieldMapping[key], values[key]));
    }, {}));
};
var salesforceFieldMapping = {
    entrance_url: "00N1i000001A0eY",
    referrer_url: "00N1i000001A0eT",
    lead_source: "lead_source",
    conversion_url: "00N1i000002WWRT",
    last_name: "last_name",
    name: "last_name",
    email: "email",
    phone: "phone",
    comment: "00N58000007Q0vz",
    record_type: "recordType",
    oid: "oid",
    city: "00N5800000CZO0T",
    caterer_type: "00N1i000002IQkc",
    first_name: "first_name",
    zip_code: "zip",
    address: "street",
    caterer_name: "company"
};


/***/ }),

/***/ 42325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ Mouseflow; }
/* harmony export */ });
// Source: https://help.mouseflow.com/en/articles/4274450-forms-with-no-successful-submits
var FORM_SUBMIT_ATTEMPT = "formSubmitAttempt";
var FORM_SUBMIT_SUCCESS = "formSubmitSuccess";
var FORM_SUBMIT_FAILURE = "formSubmitFailure";
function mouseflowNotify(type, htmlId) {
    if (typeof htmlId !== "string") {
        return;
    }
    if (!window._mfq) {
        window._mfq = [];
    }
    window._mfq.push([
        type,
        "#".concat(htmlId)
    ]);
}
var Mouseflow = {
    notify: {
        formSubmitAttempt: function formSubmitAttempt(formId) {
            mouseflowNotify(FORM_SUBMIT_ATTEMPT, formId);
        },
        formSubmitSuccess: function formSubmitSuccess(formId) {
            mouseflowNotify(FORM_SUBMIT_SUCCESS, formId);
        },
        formSubmitFailure: function formSubmitFailure(formId) {
            mouseflowNotify(FORM_SUBMIT_FAILURE, formId);
        }
    }
};


/***/ }),

/***/ 50033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _caterer_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(86631);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckCircle.js
var CheckCircle = __webpack_require__(81395);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Send.js
var Send = __webpack_require__(43910);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(59251);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 12 modules
var TextField = __webpack_require__(77269);
;// CONCATENATED MODULE: ./src/caterers/components/FormFieldGroup.js



function FormFieldGroup(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        mb: 2,
        className: "form-field-group",
        children: children
    });
}
/* harmony default export */ var components_FormFieldGroup = (FormFieldGroup);

;// CONCATENATED MODULE: ./src/caterers/components/FormField.js









function FormField(_param) {
    var field = _param.field, _form = _param.form, touched = _form.touched, errors = _form.errors, helperText = _param.helperText, _variant = _param.variant, variant = _variant === void 0 ? "filled" : _variant, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? true : _fullWidth, _label = _param.label, label = _label === void 0 ? "" : _label, _required = _param.required, required = _required === void 0 ? false : _required, _type = _param.type, type = _type === void 0 ? "text" : _type, props = (0,_object_without_properties/* default */.Z)(_param, [
        "field",
        "form",
        "helperText",
        "variant",
        "fullWidth",
        "label",
        "required",
        "type"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var fieldError = (0,formik_esm/* getIn */.u9)(errors, field.name);
    var showError = (0,formik_esm/* getIn */.u9)(touched, field.name) && !!fieldError;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FormFieldGroup, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            error: showError,
            helperText: showError && t(fieldError) || helperText
        }, field), {
            variant: variant,
            fullWidth: fullWidth,
            label: required ? "".concat(label, " *") : label,
            autoComplete: "off",
            type: type
        }), props))
    });
}
/* harmony default export */ var components_FormField = (FormField);

// EXTERNAL MODULE: ./src/caterers/constants.js
var constants = __webpack_require__(32646);
// EXTERNAL MODULE: ./src/caterers/services/webToLeadData.js
var webToLeadData = __webpack_require__(89329);
// EXTERNAL MODULE: ./src/lib/bugsnag.js
var bugsnag = __webpack_require__(45817);
// EXTERNAL MODULE: ./src/lib/mouseflow/index.js
var mouseflow = __webpack_require__(42325);
// EXTERNAL MODULE: ./src/lib/yup.ts
var yup = __webpack_require__(33448);
// EXTERNAL MODULE: ./src/shared/components/FormikFormField.js + 2 modules
var FormikFormField = __webpack_require__(3317);
// EXTERNAL MODULE: ./src/shared/services/webToLeadRequest.js + 1 modules
var webToLeadRequest = __webpack_require__(91902);
;// CONCATENATED MODULE: ./src/caterers/components/ContactCatererForm.js





function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  padding-bottom: ",
        "px;\n\n  ",
        " {\n    flex-direction: column;\n    align-items: start;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .MuiFilledInput-root {\n    border-radius: ",
        "px;\n    padding: ",
        "px;\n    background-color: ",
        ";\n    border: 1px solid transparent;\n    line-height: ",
        ";\n\n    &:hover {\n      background-color: ",
        ";\n      border: 1px solid ",
        ";\n    }\n\n    &:active,\n    &:focus,\n    &:focus-visible {\n      border: 1px solid ",
        ";\n    }\n  }\n\n  .MuiFilledInput-underline:before {\n    border-bottom: none;\n  }\n\n  .MuiFilledInput-underline:after {\n    border-bottom: none;\n  }\n\n  .MuiInputBase-inputMultiline {\n    cursor: auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


















var FORM_ID = "contact-caterer-form";
function ContactCatererForm(param) {
    var catererName = param.catererName, openContactCatererForm = param.openContactCatererForm, setOpenContactCatererForm = param.setOpenContactCatererForm, citySlug = param.citySlug;
    var t = (0,useTranslation/* useTranslation */.$)("caterers").t;
    var handleClose = function() {
        setOpenContactCatererForm(false);
    };
    var cities = (0,react.useMemo)(function() {
        return t("common:cities", {
            returnObjects: true
        });
    }, [
        t, 
    ]);
    var ref = (0,react.useState)(false), contactFormSubmitted = ref[0], setContactFormSubmitted = ref[1];
    var ref1 = (0,react.useState)(false), emailAddress = ref1[0], setEmailAddress = ref1[1];
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        mouseflow/* Mouseflow.notify.formSubmitAttempt */.s.notify.formSubmitAttempt(FORM_ID);
                        return [
                            4,
                            (0,webToLeadRequest/* webToLeadRequest */.v)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                caterer_name: catererName,
                                city: cities[citySlug] || citySlug,
                                record_type: constants/* CUSTOMER_LEAD_RECORD_TYPE */.f,
                                comment: "\n      -- COMMENT --\n      Contact Caterer Button: ".concat(catererName, "\n      Comment: ").concat(values.comment, "\n    ")
                            }), webToLeadData/* webToLeadData */.i)
                        ];
                    case 1:
                        _state.sent();
                        setContactFormSubmitted(true);
                        setEmailAddress(values.email);
                        mouseflow/* Mouseflow.notify.formSubmitSuccess */.s.notify.formSubmitSuccess(FORM_ID);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        mouseflow/* Mouseflow.notify.formSubmitFailure */.s.notify.formSubmitFailure(FORM_ID);
                        bugsnag/* default.notify */.Z.notify(new Error("[Error trying to submit a webtolead form] with data: ".concat(JSON.stringify(values))));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            open: openContactCatererForm,
            onClose: handleClose,
            anchor: "bottom",
            disableAutoFocus: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    m: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    })
                }),
                contactFormSubmitted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            position: "absolute",
                            right: 0,
                            top: 0,
                            m: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                            md: {
                                width: 590
                            },
                            p: 3,
                            mt: 2,
                            pb: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBox, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                            variant: "subtitle1",
                                            sm: {
                                                ml: 1
                                            },
                                            color: "inherit",
                                            children: t("contactCaterer.success")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                    variant: "body2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                        t: t,
                                        i18nKey: "contactCaterer.confirmation",
                                        values: {
                                            email: emailAddress
                                        },
                                        components: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            textAlign: "center",
                            mb: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Button, {
                                size: "lg",
                                variant: "secondary",
                                role: "button",
                                "aria-label": "submit",
                                id: "contact-caterer-modal-continue",
                                onClick: handleClose,
                                children: t("contactCaterer.continue")
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                    md: {
                        width: 590
                    },
                    p: 3,
                    pb: 4,
                    mx: "auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            variant: "subtitle1",
                            component: "h1",
                            children: "".concat(t("contactCaterer.title"), " ").concat(catererName)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            variant: "body2",
                            mb: 3,
                            children: t("contactCaterer.subtitle")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                            id: FORM_ID,
                            initialValues: {
                                name: "",
                                email: "",
                                comment: "",
                                phone: ""
                            },
                            validationSchema: yup/* default.object */.Z.object({
                                name: yup/* default.string */.Z.string().required(t("formErrors.isRequired")),
                                email: yup/* default.string */.Z.string().required(t("formErrors.emailRequired")).email(t("formErrors.correctFormatEmail")),
                                comment: yup/* default.string */.Z.string().required(t("formErrors.isRequired")),
                                phone: yup/* default.string */.Z.string().required(t("formErrors.isRequired")).matches(constants/* PHONE_NUMBER_REGEX */.d0, t("formErrors.phone"))
                            }),
                            onSubmit: handleSubmit,
                            enableReinitialize: true,
                            children: function(formikBag) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                            pb: 2,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.InputLabel, {
                                                                required: true,
                                                                children: t("contactCaterer.message")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledField, {
                                                                placeholder: "".concat(t("contactCaterer.question1"), " ").concat(catererName, " ").concat(t("contactCaterer.question2")),
                                                                name: "comment",
                                                                component: components_FormField,
                                                                multiline: true,
                                                                rows: 4
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                    container: true,
                                                    spacing: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            container: true,
                                                            item: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                item: true,
                                                                md: 6,
                                                                xs: 12,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                    required: true,
                                                                    label: t("contactCaterer.name"),
                                                                    placeholder: t("contactCaterer.name"),
                                                                    name: "name",
                                                                    component: FormikFormField/* default */.Z
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            item: true,
                                                            md: 6,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                required: true,
                                                                label: t("contactCaterer.email"),
                                                                placeholder: t("contactCaterer.email"),
                                                                name: "email",
                                                                component: FormikFormField/* default */.Z,
                                                                helperText: t("contactCaterer.helper")
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            item: true,
                                                            md: 6,
                                                            xs: 12,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                required: true,
                                                                label: t("contactCaterer.phone"),
                                                                placeholder: t("contactCaterer.phone"),
                                                                name: "phone",
                                                                component: FormikFormField/* default */.Z,
                                                                helperText: t("contactCaterer.phoneHelper")
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                            textAlign: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Button, {
                                                disabled: !formikBag.dirty,
                                                size: "lg",
                                                variant: "secondary",
                                                type: "submit",
                                                role: "button",
                                                "aria-label": "submit",
                                                id: "contact-caterer-modal-submit",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                                        display: "flex",
                                                        mr: 1,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Send/* default */.Z, {
                                                            fontSize: "small"
                                                        })
                                                    }),
                                                    t("contactCaterer.submit")
                                                ]
                                            })
                                        })
                                    ]
                                });
                            }
                        })
                    ]
                })
            ]
        })
    });
}
var StyledBox = styled_components_browser_esm["default"].div(_templateObject(), function(props) {
    return props.theme.palette.secondary.light;
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var StyledField = (0,styled_components_browser_esm["default"])(formik_esm/* Field */.gN)(_templateObject1(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1.5);
}, function(props) {
    return props.theme.palette.text.disabled;
}, function(props) {
    return props.theme.typography.body1.lineHeight;
}, function(props) {
    return props.theme.palette.text.disabled;
}, function(props) {
    return props.theme.palette.grey[400];
}, function(props) {
    return props.theme.palette.grey[600];
});
/* harmony default export */ var components_ContactCatererForm = (ContactCatererForm);

// EXTERNAL MODULE: ./src/shared/components/BackgroundImage.tsx
var BackgroundImage = __webpack_require__(21890);
;// CONCATENATED MODULE: ./src/caterers/components/BookCateringCTA.js

function BookCateringCTA_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  padding: ",
        "px;\n"
    ]);
    BookCateringCTA_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BookCateringCTA_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0.9;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: ",
        "px;\n  background: white;\n  box-shadow: 0 4px 40px rgba(62, 41, 29, 0.08);\n  border-radius: ",
        "px;\n"
    ]);
    BookCateringCTA_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var BookCateringCTA = function(param) {
    var catererName = param.catererName, citySlug = param.citySlug;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var t = (0,useTranslation/* useTranslation */.$)("caterers").t;
    var ref = (0,react.useState)(false), openContactCatererForm = ref[0], setOpenContactCatererForm = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMainContainer, {
        mobile: mobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* default */.Z, {
                alt: "",
                src: "/artifacts/images/caterer/book_catering_cta_background.webp",
                layout: "fill",
                objectFit: "cover",
                objectPosition: "center"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCTAHeader, {
                        variant: "h5",
                        children: t("caterer.bookCateringHeader")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCTAText, {
                        children: t("caterer.bookCateringText")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Button, {
                        size: "lg",
                        variant: "primary",
                        rounded: true,
                        onClick: function() {
                            return setOpenContactCatererForm(true);
                        },
                        children: t("caterer.bookCateringButtonLabel")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ContactCatererForm, {
                        catererName: catererName,
                        openContactCatererForm: openContactCatererForm,
                        setOpenContactCatererForm: setOpenContactCatererForm,
                        citySlug: citySlug
                    })
                ]
            })
        ]
    });
};
var StyledMainContainer = (0,styled_components_browser_esm["default"])(esm.Box)(BookCateringCTA_templateObject(), function(props) {
    return props.theme.spacing(2);
});
var StyledInnerContainer = (0,styled_components_browser_esm["default"])(esm.Box)(BookCateringCTA_templateObject1(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(1);
});
var StyledCTAHeader = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject2(), function(props) {
    return props.theme.spacing(1);
});
var StyledCTAText = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject3(), function(props) {
    return props.theme.spacing(2);
});
/* harmony default export */ var components_BookCateringCTA = (BookCateringCTA);

// EXTERNAL MODULE: ./src/shared/constants.ts
var shared_constants = __webpack_require__(98769);
;// CONCATENATED MODULE: ./src/caterers/components/CatererDeliverySchedule.js

function CatererDeliverySchedule_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  margin-bottom: ",
        "px;\n"
    ]);
    CatererDeliverySchedule_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CatererDeliverySchedule_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: ",
        "px;\n  row-gap: ",
        "px;\n"
    ]);
    CatererDeliverySchedule_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var toTwentyFourHourTimeFormat = function() {
    var amPmString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var amPmRegex = /([0-9:]+(am|pm))/gi;
    return amPmString.replace(amPmRegex, function(match) {
        var isPm = match.toLowerCase().includes("pm");
        match = match.replace(/(pm|am)/gi, function() {
            return "";
        });
        var date = new Date("1/1/2022 ".concat(match, ":00"));
        if (isPm) {
            date = new Date(date.getTime() + 12 * 3600 * 1000);
        }
        return date.toLocaleTimeString("de-DE", {
            hour: "numeric",
            minute: "2-digit"
        });
    });
};
var CatererDeliverySchedule = function(param) {
    var deliverySchedule = param.deliverySchedule;
    var t = (0,useTranslation/* useTranslation */.$)("caterers").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                children: t("caterer.deliveryScheduleHeader")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid, {
                children: shared_constants/* DAYS_OF_WEEK.map */.sb.map(function(day) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                children: t("common:days_of_week.".concat(day))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                children: toTwentyFourHourTimeFormat(deliverySchedule[day])
                            })
                        ]
                    });
                })
            })
        ]
    });
};
var StyledHeader = (0,styled_components_browser_esm["default"])(esm.Typography)(CatererDeliverySchedule_templateObject(), function(props) {
    return props.theme.typography.h6.fontSize;
}, function(props) {
    return props.theme.typography.h6.fontWeight;
}, function(props) {
    return props.theme.spacing(1);
});
var StyledGrid = (0,styled_components_browser_esm["default"])(esm.Box)(CatererDeliverySchedule_templateObject1(), function(props) {
    return props.theme.spacing(3);
}, function(props) {
    return props.theme.spacing(1);
});
/* harmony default export */ var components_CatererDeliverySchedule = (CatererDeliverySchedule);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Link/Link.js
var Link = __webpack_require__(89659);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
;// CONCATENATED MODULE: ./src/shared/components/Map.js

function Map_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    Map_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Map_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    Map_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var DESKTOP_MAP_WIDTH = 530;
var DESKTOP_MAP_HEIGHT = 240;
var MOBILE_MAP_WIDTH = 340;
var MOBILE_MAP_HEIGHT = 140;
var Map = function(param) {
    var address = param.address, catererName = param.catererName;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var staticMapUrlOptions = {
        center: address,
        markers: address,
        size: mobile ? "".concat(MOBILE_MAP_WIDTH, "x").concat(MOBILE_MAP_HEIGHT) : "".concat(DESKTOP_MAP_WIDTH, "x").concat(DESKTOP_MAP_HEIGHT),
        scale: 1,
        key: "AIzaSyCrunI86W7p8zk5yoGX9i1s0SzIJ7GTRDU"
    };
    var externalMapUrlOptions = {
        api: "1",
        query: address
    };
    var staticMapUrl = "https://maps.googleapis.com/maps/api/staticmap?".concat((0,lib.stringify)(staticMapUrlOptions));
    var externalMapUrl = "https://www.google.com/maps/search/".concat((0,lib.stringify)(externalMapUrlOptions));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: externalMapUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImg, {
                src: staticMapUrl,
                alt: "".concat(catererName, " location")
            })
        })
    });
};
var StyledContainer = styled_components_browser_esm["default"].div(Map_templateObject());
var StyledImg = styled_components_browser_esm["default"].img(Map_templateObject1());
/* harmony default export */ var components_Map = (Map);

;// CONCATENATED MODULE: ./src/caterers/components/BookCateringCTAContainer.js

function BookCateringCTAContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  flex-direction: column;\n  grid-template-columns: 1fr 1fr;\n  column-gap: ",
        "px;\n  row-gap: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    BookCateringCTAContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var BookCateringCTAContainer = function(param) {
    var unsignedCatererAddress = param.unsignedCatererAddress, deliverySchedule = param.deliverySchedule, catererName = param.catererName, citySlug = param.citySlug;
    var theme = (0,useTheme/* default */.Z)();
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var t = (0,useTranslation/* useTranslation */.$)("caterers").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BookCateringCTAContainer_StyledContainer, {
        mobile: mobile,
        children: [
            unsignedCatererAddress && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Map, {
                        address: unsignedCatererAddress,
                        catererName: catererName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Typography, {
                        mt: 2,
                        component: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                display: "inline",
                                fontWeight: theme.typography[mobile ? "body1" : "h3"].fontWeight,
                                children: t("caterer.catererAddress")
                            }),
                            unsignedCatererAddress
                        ]
                    })
                ]
            }),
            deliverySchedule && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CatererDeliverySchedule, {
                deliverySchedule: deliverySchedule
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BookCateringCTA, {
                catererName: catererName,
                citySlug: citySlug
            })
        ]
    });
};
var BookCateringCTAContainer_StyledContainer = (0,styled_components_browser_esm["default"])(esm.Box)(BookCateringCTAContainer_templateObject(), function(props) {
    return props.mobile ? "flex" : "grid";
}, function(props) {
    return props.theme.spacing(6);
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(2);
});
/* harmony default export */ var components_BookCateringCTAContainer = (BookCateringCTAContainer);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/Rating.js
var Rating = __webpack_require__(84934);
;// CONCATENATED MODULE: ./src/caterers/components/CatererHeader.js

function CatererHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  margin-top: ",
        "px;\n  margin-bottom: ",
        "px;\n  flex-direction: ",
        ";\n  flex-direction: ",
        ";\n"
    ]);
    CatererHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CatererHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0.5;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    CatererHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CatererHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    CatererHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CatererHeader_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    CatererHeader_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0.5;\n  justify-content: ",
        ";\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  overflow: hidden;\n  position: relative;\n  box-sizing: border-box;\n  border: 1px solid #f0f0f0;\n  box-shadow: ",
        ";\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}








var CATERER_LOGO_PLACEHOLDER = "/artifacts/images/caterer/placeholder_caterer_logo.webp";
function CatererHeader(param) {
    var caterer = param.caterer;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("xs");
    });
    var t = (0,useTranslation/* useTranslation */.$)("caterers").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CatererHeader_StyledContainer, {
        mobile: mobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLeftContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCatererName, {
                        mobile: mobile,
                        component: "h1",
                        children: caterer.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                        children: t("caterer.catererNameLabel", {
                            catererName: caterer.name
                        })
                    }),
                    caterer.averageRating && caterer.reviewsCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRatingContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                                score: caterer.averageRating * 10,
                                isRated: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRatingLabel, {
                                variant: "body1",
                                children: "".concat(caterer.reviewsCount, " ").concat(t("caterer.reviewsCount"))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrapper, {
                mobile: mobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageContainer, {
                    mobile: mobile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "",
                        layout: "fill",
                        priority: true,
                        src: caterer.logo || CATERER_LOGO_PLACEHOLDER,
                        objectFit: "cover",
                        objectPosition: "center"
                    })
                })
            })
        ]
    });
}
var CatererHeader_StyledContainer = (0,styled_components_browser_esm["default"])(esm.Box)(CatererHeader_templateObject(), function(props) {
    return props.theme.spacing(14);
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.mobile ? "column" : "row";
}, function(props) {
    return props.mobile ? "flex-start" : "center";
});
var StyledLeftContainer = (0,styled_components_browser_esm["default"])(esm.Box)(CatererHeader_templateObject1());
var StyledCatererName = (0,styled_components_browser_esm["default"])(esm.Typography)(CatererHeader_templateObject2(), function(props) {
    return props.theme.typography[props.mobile ? "h4" : "h3"].fontSize;
}, function(props) {
    return props.theme.typography.h3.fontWeight;
});
var StyledRatingContainer = (0,styled_components_browser_esm["default"])(esm.Box)(CatererHeader_templateObject3(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(1);
});
var StyledRatingLabel = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject4(), function(props) {
    return props.theme.typography.body2.fontSize;
});
var StyledImageWrapper = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject5(), function(props) {
    return props.mobile ? "center" : "flex-end";
});
var StyledImageContainer = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject6(), function(props) {
    return props.mobile ? 340 : 270;
}, function(props) {
    return props.mobile ? 240 : 195;
}, function(props) {
    return "".concat(props.mobile ? "unset" : "0 4px 40px rgba(0, 0, 0, 0.08)");
}, function(props) {
    return props.theme.spacing(0.5);
});
/* harmony default export */ var components_CatererHeader = (CatererHeader);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(67265);
// EXTERNAL MODULE: ./src/shared/components/ScrollToTopButton.js
var ScrollToTopButton = __webpack_require__(42124);
;// CONCATENATED MODULE: ./src/caterers/components/ClaimCatererProfileCTA.js

function ClaimCatererProfileCTA_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: ",
        ";\n  justify-content: space-between;\n  padding: ",
        "px;\n  background: #f8f8f8;\n"
    ]);
    ClaimCatererProfileCTA_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClaimCatererProfileCTA_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: ",
        "px;\n"
    ]);
    ClaimCatererProfileCTA_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClaimCatererProfileCTA_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  margin-left: ",
        "px;\n"
    ]);
    ClaimCatererProfileCTA_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClaimCatererProfileCTA_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    ClaimCatererProfileCTA_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ClaimCatererProfileCTA_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        "px;\n  margin-top: ",
        "px;\n  margin-bottom: ",
        "px;\n"
    ]);
    ClaimCatererProfileCTA_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}







var ClaimCatererProfileCTA = function(param) {
    var catererName = param.catererName, openClaimCatererProfileForm = param.openClaimCatererProfileForm;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var t = (0,useTranslation/* useTranslation */.$)("caterers").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClaimCatererProfileCTA_StyledContainer, {
        mobile: mobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClaimCatererProfileCTA_StyledLeftContainer, {
                mobile: mobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCTATextContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCTATextHeader, {
                                mobile: mobile,
                                children: "".concat(t("caterer.customizeProfileCTAHeader")).concat(catererName, "?")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                children: t("caterer.customizeProfileCTALabel")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                onClick: openClaimCatererProfileForm,
                outlined: true,
                mobile: mobile,
                children: t("caterer.customizeProfileButton")
            })
        ]
    });
};
var ClaimCatererProfileCTA_StyledContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileCTA_templateObject(), function(props) {
    return props.mobile ? "column" : "row";
}, function(props) {
    return props.theme.spacing(1);
});
var ClaimCatererProfileCTA_StyledLeftContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileCTA_templateObject1(), function(props) {
    return props.theme.spacing(props.mobile ? 2 : 0);
});
var StyledCTATextContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileCTA_templateObject2(), function(props) {
    return props.theme.spacing(2);
});
var StyledCTATextHeader = (0,styled_components_browser_esm["default"])(esm.Typography)(ClaimCatererProfileCTA_templateObject3(), function(props) {
    return props.theme.typography[props.mobile ? "body1" : "subtitle1"].fontSize;
}, function(props) {
    return props.theme.typography[props.mobile ? "h3" : "subtitle1"].fontWeight;
});
var StyledButton = (0,styled_components_browser_esm["default"])(ScrollToTopButton/* default */.Z)(ClaimCatererProfileCTA_templateObject4(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(props.mobile ? 0 : 3);
}, function(props) {
    return props.theme.spacing(props.mobile ? 1 : 3);
});
/* harmony default export */ var components_ClaimCatererProfileCTA = (ClaimCatererProfileCTA);

;// CONCATENATED MODULE: ./src/caterers/components/ClaimCatererProfileForm.js





function ClaimCatererProfileForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  padding-bottom: ",
        "px;\n\n  ",
        " {\n    flex-direction: column;\n    align-items: start;\n  }\n"
    ]);
    ClaimCatererProfileForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClaimCatererProfileForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: ",
        ";\n  padding-top: ",
        "px;\n  max-height: 80vh;\n  overflow-y: auto;\n  padding-left: ",
        "px;\n  padding-right: ",
        "px;\n"
    ]);
    ClaimCatererProfileForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClaimCatererProfileForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  flex: 0.3;\n  background-image: url('/static/images/caterer/claim_caterer_profile_modal_background.webp');\n  background-size: cover;\n  background-position: center;\n"
    ]);
    ClaimCatererProfileForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClaimCatererProfileForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 0.2;\n  justify-content: center;\n  align-items: center;\n  background-color: white;\n  box-shadow: 0 4px 40px rgba(62, 41, 29, 0.08);\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    ClaimCatererProfileForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

















var ClaimCatererProfileForm_FORM_ID = "claim-caterer-profile-form";
function ClaimCatererProfileForm(param) {
    var unsignedCaterer = param.unsignedCaterer, isClaimCatererProfileFormOpened = param.isClaimCatererProfileFormOpened, closeClaimCatererProfileForm = param.closeClaimCatererProfileForm;
    var ref;
    var t = (0,useTranslation/* useTranslation */.$)("caterers").t;
    var handleClose = function() {
        closeClaimCatererProfileForm(false);
    };
    var ref1 = (0,react.useState)(false), isClaimCatererProfileFormSubmitted = ref1[0], setIsClaimCatererProfileFormSubmitted = ref1[1];
    var ref2 = (0,react.useState)(false), emailAddress = ref2[0], setEmailAddress = ref2[1];
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var catererName = unsignedCaterer.name, _address = unsignedCaterer.address, address = _address.street, cityWithPLZ = _address.city;
    var zipCode = cityWithPLZ === null || cityWithPLZ === void 0 ? void 0 : cityWithPLZ.match(constants/* GET_POSTCODE_REGEXP */.z3)[0];
    var city = ((ref = unsignedCaterer.city) === null || ref === void 0 ? void 0 : ref.fields.name) || (cityWithPLZ === null || cityWithPLZ === void 0 ? void 0 : cityWithPLZ.split(" ")[1]) || "";
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        mouseflow/* Mouseflow.notify.formSubmitAttempt */.s.notify.formSubmitAttempt(ClaimCatererProfileForm_FORM_ID);
                        return [
                            4,
                            (0,webToLeadRequest/* webToLeadRequest */.v)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                record_type: shared_constants/* SALESFORCE_LEAD_RECORD_TYPES_MAPPING.Partner Lead */.Ik["Partner Lead"]
                            }), webToLeadData/* webToLeadData */.i)
                        ];
                    case 1:
                        _state.sent();
                        setIsClaimCatererProfileFormSubmitted(true);
                        setEmailAddress(values.email);
                        mouseflow/* Mouseflow.notify.formSubmitSuccess */.s.notify.formSubmitSuccess(ClaimCatererProfileForm_FORM_ID);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        mouseflow/* Mouseflow.notify.formSubmitFailure */.s.notify.formSubmitFailure(ClaimCatererProfileForm_FORM_ID);
                        bugsnag/* default.notify */.Z.notify(new Error("[Error trying to submit a webtolead form] with data: ".concat(JSON.stringify(values))));
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
            open: isClaimCatererProfileFormOpened,
            onClose: handleClose,
            anchor: "bottom",
            disableAutoFocus: true,
            maxWidth: "md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                    position: "absolute",
                    right: 0,
                    top: 0,
                    m: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                    })
                }),
                isClaimCatererProfileFormSubmitted ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            position: "absolute",
                            right: 0,
                            top: 0,
                            m: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                onClick: handleClose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                            p: 3,
                            mt: 2,
                            pb: 4,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClaimCatererProfileForm_StyledBox, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                            fontSize: "small"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                            variant: "subtitle1",
                                            sm: {
                                                ml: 1
                                            },
                                            color: "inherit",
                                            children: t("claimCatererProfile.success")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                    variant: "body2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                        t: t,
                                        i18nKey: "claimCatererProfile.confirmation",
                                        values: {
                                            email: emailAddress
                                        },
                                        components: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {}, "strong")
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            textAlign: "center",
                            mb: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Button, {
                                size: "lg",
                                variant: "secondary",
                                role: "button",
                                "aria-label": "submit",
                                id: "contact-caterer-modal-continue",
                                onClick: handleClose,
                                children: t("claimCatererProfile.continue")
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    id: ClaimCatererProfileForm_FORM_ID,
                    initialValues: {
                        caterer_name: catererName,
                        first_name: "",
                        last_name: "",
                        zip_code: zipCode,
                        city: city,
                        address: address,
                        email: "",
                        phone: unsignedCaterer === null || unsignedCaterer === void 0 ? void 0 : unsignedCaterer.sourceJson.phone
                    },
                    validationSchema: yup/* default.object */.Z.object({
                        caterer_name: yup/* default.string */.Z.string().required(t("formErrors.isRequired")),
                        first_name: yup/* default.string */.Z.string().required(t("formErrors.isRequired")),
                        last_name: yup/* default.string */.Z.string().required(t("formErrors.isRequired")),
                        zip_code: yup/* default.string */.Z.string().required(t("formErrors.isRequired")).matches(constants/* PLZ_REGEX */.WU, t("formErrors.zipCode")),
                        city: yup/* default.string */.Z.string().required(t("formErrors.isRequired")),
                        address: yup/* default.string */.Z.string().required(t("formErrors.isRequired")),
                        email: yup/* default.string */.Z.string().required(t("formErrors.emailRequired")).email(t("formErrors.correctFormatEmail")),
                        phone: yup/* default.string */.Z.string().required(t("formErrors.isRequired")).matches(constants/* PHONE_NUMBER_REGEX */.d0, t("formErrors.phone"))
                    }),
                    onSubmit: handleSubmit,
                    enableReinitialize: true,
                    children: function(formikBag) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Form */.l0, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                display: "flex",
                                flexDirection: "column",
                                flex: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                        display: "flex",
                                        flexDirection: "row",
                                        flex: 0.8,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFormContainer, {
                                                mobile: mobile,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                                        variant: "h4",
                                                        component: "h1",
                                                        children: t("claimCatererProfile.title")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                                        variant: "body2",
                                                        mt: 1,
                                                        mb: 4,
                                                        children: t("claimCatererProfile.subtitle")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                                        pb: 2,
                                                        mt: 4,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                            container: true,
                                                            spacing: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        required: true,
                                                                        label: t("claimCatererProfile.catererName"),
                                                                        placeholder: t("claimCatererProfile.catererName"),
                                                                        name: "caterer_name",
                                                                        component: FormikFormField/* default */.Z
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    md: 6,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        required: true,
                                                                        label: t("claimCatererProfile.firstName"),
                                                                        placeholder: t("claimCatererProfile.firstName"),
                                                                        name: "first_name",
                                                                        component: FormikFormField/* default */.Z
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    md: 6,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        required: true,
                                                                        label: t("claimCatererProfile.lastName"),
                                                                        placeholder: t("claimCatererProfile.lastName"),
                                                                        name: "last_name",
                                                                        component: FormikFormField/* default */.Z
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        required: true,
                                                                        label: t("claimCatererProfile.address"),
                                                                        placeholder: t("claimCatererProfile.address"),
                                                                        name: "address",
                                                                        component: FormikFormField/* default */.Z
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    md: 3,
                                                                    xs: 5,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        required: true,
                                                                        label: t("claimCatererProfile.zipCode"),
                                                                        placeholder: t("claimCatererProfile.zipCode"),
                                                                        name: "zip_code",
                                                                        component: FormikFormField/* default */.Z
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    md: 9,
                                                                    xs: 7,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        required: true,
                                                                        label: t("claimCatererProfile.city"),
                                                                        placeholder: t("claimCatererProfile.city"),
                                                                        name: "city",
                                                                        component: FormikFormField/* default */.Z
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    md: 6,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        required: true,
                                                                        label: t("claimCatererProfile.email"),
                                                                        placeholder: t("claimCatererProfile.email"),
                                                                        name: "email",
                                                                        component: FormikFormField/* default */.Z
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    md: 6,
                                                                    xs: 12,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                                        required: true,
                                                                        label: t("claimCatererProfile.phone"),
                                                                        placeholder: t("claimCatererProfile.phone"),
                                                                        name: "phone",
                                                                        component: FormikFormField/* default */.Z
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            !mobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideImage, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubmitButtonContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Button, {
                                            disabled: !formikBag.dirty,
                                            size: "lg",
                                            variant: "primary",
                                            type: "submit",
                                            role: "button",
                                            "aria-label": "submit",
                                            id: "contact-caterer-modal-submit",
                                            children: t("claimCatererProfile.submit")
                                        })
                                    })
                                ]
                            })
                        });
                    }
                })
            ]
        })
    });
}
var ClaimCatererProfileForm_StyledBox = styled_components_browser_esm["default"].div(ClaimCatererProfileForm_templateObject(), function(props) {
    return props.theme.palette.secondary.light;
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var StyledFormContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileForm_templateObject1(), function(props) {
    return props.mobile ? 1 : 0.7;
}, function(props) {
    return props.theme.spacing(3);
}, function(props) {
    return props.theme.spacing(props.mobile ? 3 : 7);
}, function(props) {
    return props.theme.spacing(props.mobile ? 3 : 11.5);
});
var StyledSideImage = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileForm_templateObject2());
var StyledSubmitButtonContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileForm_templateObject3(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
});
/* harmony default export */ var components_ClaimCatererProfileForm = (ClaimCatererProfileForm);

;// CONCATENATED MODULE: ./src/static_pages/caterer/svg/ValuePropositionOne.jsx


function ValuePropositionOne() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 248,
        height: 270,
        viewBox: "0 0 248 270",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#prefix__clip0)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M215.292 13.992a.581.581 0 00-.829-.052l-46.914 40.941-66.074 60.374-75.757 37.676c-.311.155-.415.518-.26.829a.57.57 0 00.519.311c.103 0 .155 0 .259-.052l75.86-37.727c.052 0 .104-.052.155-.104l66.074-60.374 46.915-40.94c.207-.208.259-.623.052-.882z",
                        fill: "#F2F2F2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M2.52 11.401H.707V240.72H2.52V11.401zM2.779 240.72H.707v1.814H247.5v-1.814H2.779zM39.078 233.62H13.186c-1.45 0-2.64-1.969-2.64-4.405v-59.752c0-2.436 1.19-4.405 2.64-4.405h25.892c1.45 0 2.64 1.969 2.64 4.405v59.752c0 2.436-1.19 4.405-2.64 4.405zM86.25 233.62H60.36c-1.45 0-2.641-1.969-2.641-4.405V112.768c0-2.436 1.191-4.405 2.64-4.405h25.892c1.45 0 2.64 1.969 2.64 4.405v116.395c0 2.488-1.19 4.457-2.64 4.457zM133.424 233.62h-25.891c-1.45 0-2.641-2.539-2.641-5.649v-76.128c0-3.11 1.191-5.649 2.641-5.649h25.891c1.45 0 2.641 2.539 2.641 5.649v76.128c0 3.11-1.139 5.649-2.641 5.649zM180.65 233.62h-25.891c-1.45.052-2.59-1.814-2.641-4.25V90.225c.051-2.384 1.242-4.302 2.641-4.25h25.891c1.449-.052 2.589 1.814 2.64 4.25v139.197c-.051 2.384-1.242 4.25-2.64 4.198zM227.616 233.62h-25.891c-1.45 0-2.641-1.969-2.641-4.405V50.113c0-2.435 1.191-4.405 2.641-4.405h25.891c1.45 0 2.641 1.97 2.641 4.405v179.05c0 2.488-1.191 4.457-2.641 4.457z",
                        fill: "#DFDFDF"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M63.83 266.424c-.208-1.192-3.988-2.228-5.852-.674-.932.778-1.553 2.384-1.036 3.058.208.259-.621.726.156.726 2.537.051 6.939-1.97 6.731-3.11z",
                        fill: "url(#prefix__paint0_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M59.687 266.424l-3.935.207c1.346-2.487-.26-9.224-.26-9.224l4.247.103s-.104 1.97-.363 4.872c-.103.985.052 2.487.311 4.042z",
                        fill: "#F4A583"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M60.205 266.372s-4.66-1.088-5.178-.155c-.518.933-.88 3.42 2.07 3.317 2.952-.052 3.367-2.384 3.108-3.162z",
                        fill: "url(#prefix__paint1_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M107.585 266.994c-.103-1.192-3.78-2.539-5.799-1.14-.984.674-1.761 2.228-1.295 2.954.155.259-.673.674.104.726 2.537.259 7.094-1.348 6.99-2.54z",
                        fill: "url(#prefix__paint2_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M102.873 266.787l-3.884.415c1.243-2.54-.776-9.173-.776-9.173l4.246-.104s0 1.969-.104 4.872c-.052.984.207 2.435.518 3.99z",
                        fill: "#F4A583"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M103.961 266.631s-4.557-1.451-5.179-.57c-.57.881-1.19 3.317 1.761 3.524 3.055.104 3.625-2.124 3.418-2.954z",
                        fill: "url(#prefix__paint3_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M74.496 140.13c-1.035 17.983-2.537 36.64-4.504 56.022a1226.316 1226.316 0 01-8.234 64.157c-3.832 1.347-7.405 0-7.405 0s-4.505-7.411-7.922-27c-2.227-12.593-2.382-12.438-2.382-14.614-.104-11.09 3.78-14.303 4.505-24.202.673-9.173-2.227-11.919-3.987-22.232-1.347-7.929-1.865-19.486 2.382-34.618 9.165.829 18.382 1.658 27.547 2.487z",
                        fill: "url(#prefix__paint4_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M89.047 130.595a376.104 376.104 0 0113.257 65.557c2.744 24.927 2.692 47.055 1.605 65.297-1.657.467-3.366.933-5.023 1.399-9.735-10.209-13.256-19.589-14.55-26.43-1.968-10.157.983-13.577-1.606-25.03-.57-2.643-1.45-5.494-11.133-24.461-9.27-18.138-11.133-20.781-12.687-27.311-2.226-9.276-1.657-17.568-.776-23.061a4675.035 4675.035 0 0130.913-5.96z",
                        fill: "url(#prefix__paint5_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M135.651 99.967l16.57-38.815c.829-1.918-.259-4.146-2.33-4.665l-30.292-7.358a3.35 3.35 0 00-3.936 2.02l-15.224 37.314c-.776 1.865.259 3.99 2.175 4.56l28.998 8.862c1.554.466 3.314-.363 4.039-1.918z",
                        fill: "#1C1B3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M133.58 99.294l14.292-36.225c.725-1.814-.259-3.887-2.02-4.353l-26.202-6.893c-1.398-.362-2.848.415-3.417 1.866L103.08 88.514c-.673 1.71.207 3.68 1.864 4.25l25.011 8.292c1.502.518 3.003-.259 3.625-1.762z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M144.402 87.426l.518-4.56 2.641-5.027c.362-.674.57-1.451.57-2.229v-4.975l-3.159 7.36s-2.071-1.866-2.9-2.281c-.777-.415-.673 1.192-.104 1.814.622.622-.31 5.441.311 5.96l-.207 3.005 2.33.933z",
                        fill: "#F4A583"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M119.184 58.301c-2.485-6.063-7.767-9.535-10.511-11.349-6.525-4.25-10.667-3.472-25.632-5.752-19.936-3.058-22.318-5.908-28.998-3.576C45.24 40.68 40.63 48.662 38.56 52.342c-10.615 18.449 1.812 27.829-1.398 64.623-1.295 15.029-4.66 28.089 3.366 35.759 1.708 1.606 3.573 2.487 7.353 4.197 14.965 6.737 28.376 5.597 36.558 4.768 8.958-.881 13.515-1.399 15.897-4.56 3.78-5.079-.104-11.505-.777-22.647-.466-7.981 1.346-14.355 4.971-27.052 8.441-29.54 19.418-37.52 14.654-49.129z",
                        fill: "url(#prefix__paint6_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M89.1 34.566c2.122-2.591 1.863-6.011 1.76-6.737-.26-3.057-.466-3.524-.932-4.25l-.674-.932-.103-.104c-.466-.466-2.382-1.347-2.848-1.45-1.398-.26-4.92 4.3-7.716 11.711-.155.26-.362.518-.517.777-1.295 1.97-1.45 2.592-1.916 3.162-.88 1.088-2.279 1.295-3.729 1.554-3.314.57-5.178-.725-5.696 0-.57.83.984 3.162 2.59 4.665 2.796 2.643 6.162 3.264 8.284 3.627 2.797.467 6.836 1.14 8.803-1.036 0 0 .622-.674 2.072-3.628 0 0-1.502-.155-3.107-.518-1.088-.26-1.346-.415-1.554-.518-.207-.104-.88-.519-1.139-1.296-.57-1.347.466-2.85.673-3.058.622.052 4.195-.051 5.748-1.969z",
                        fill: "#F4A583"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M92.776 21.714c.103 1.918-2.952 4.146-3.78 4.353-.104 0-.622.156-1.191.518-.104.052-.156.104-.26.208-1.087 1.192.415 3.835-.258 4.301-.518.311-1.76-.933-2.123-.622-.31.311.621 1.607.207 1.97-.31.259-.932-.363-1.657-.052-.363.155-.362.362-.984 1.088-.362.363-.777.777-1.036.985-1.346.984-3.78.518-3.935-.208-.052-.207.104-.259.207-.829 0 0 .104-.518 0-1.192-.103-.933-.984-1.97-1.76-3.265-1.399-2.384-1.45-3.887-1.399-4.353 0-.155 0-.31.052-.415.207-1.865 1.243-4.353 2.641-5.493 2.382-1.969 5.644-1.45 8.026-1.036.363.103 7.094 1.295 7.25 4.042z",
                        fill: "#1C1B3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M86.717 30.265c-.207-.985-1.502-.726-1.916.259-.414.985.104 2.384 1.088 2.591.983.207 1.087-1.555.828-2.85z",
                        fill: "#F4A583"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M86.873 28.555l.57 2.228s.517 2.643 1.76 1.866c1.035-.622 1.19-.519 1.242-.467 0 0 .104-.518.156-.933.103.622.259 1.659.103 2.799-.155 1.14-.362 2.384-1.398 3.213-.052.052-1.19.881-2.537.674 0 0-.518-.104-2.382-1.296 0 0 2.848-.622 3.055-.985.518-.984-.673-2.176-.777-4.715 0-1.037.104-1.866.207-2.384z",
                        fill: "#1C1B3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M145.334 86.545l-4.349-1.865c-2.486 2.539-5.593 4.974-8.234 4.197-3.935-1.192-2.951-8.447-7.767-21.144-5.437-14.407-11.599-18.138-14.706-19.485-1.709-.726-2.952-1.244-4.35-.881-6.628 1.606-8.803 18.863-6.939 31.82 1.036 7.255 3.107 21.558 14.81 28.347 1.657.984 10.822 6.27 19.884 2.073 7.664-3.68 12.428-12.853 11.651-23.062z",
                        fill: "url(#prefix__paint7_linear)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M215.136 18.605a3.315 3.315 0 003.314-3.317 3.315 3.315 0 10-6.628 0 3.316 3.316 0 003.314 3.317zM167.6 58.975a3.315 3.315 0 003.314-3.317 3.315 3.315 0 10-6.628 0 3.316 3.316 0 003.314 3.317zM25.666 156.403a3.315 3.315 0 003.314-3.317 3.315 3.315 0 10-6.628 0 3.315 3.315 0 003.314 3.317z",
                        fill: "#F2F2F2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M217.518 62.447c.57-.31.984-.777 1.295-1.347h2.382c-.466 1.14-1.191 2.073-2.175 2.695-.984.621-2.123.933-3.418.933-1.346 0-2.589-.363-3.624-1.089-1.036-.725-1.813-1.71-2.227-2.954h-1.605v-1.347h1.294c0-.311-.051-.57-.051-.778 0-.207 0-.466.051-.777h-1.294v-1.347h1.605c.414-1.244 1.139-2.229 2.227-2.954 1.035-.726 2.278-1.088 3.624-1.088 1.295 0 2.434.31 3.418.932a5.342 5.342 0 012.175 2.695h-2.382a2.97 2.97 0 00-1.295-1.347c-.569-.311-1.191-.467-1.916-.467-.828 0-1.605.208-2.226.57-.622.415-1.139.933-1.45 1.659h3.728v1.347h-4.091c-.051.26-.051.518-.051.777 0 .26 0 .519.051.778h4.091v1.347h-3.728c.362.726.828 1.296 1.45 1.659.621.414 1.398.57 2.226.57.725 0 1.347-.156 1.916-.467zM170.604 102.766c.569-.311.984-.778 1.294-1.348h2.382c-.466 1.141-1.191 2.073-2.175 2.695-.983.622-2.123.933-3.417.933-1.347 0-2.589-.363-3.625-1.088-1.036-.726-1.812-1.71-2.227-2.954h-1.605v-1.348h1.295c0-.31-.052-.57-.052-.777 0-.207 0-.466.052-.777h-1.295v-1.348h1.605c.415-1.243 1.14-2.228 2.227-2.954 1.036-.725 2.278-1.088 3.625-1.088 1.294 0 2.434.311 3.417.933a5.342 5.342 0 012.175 2.695h-2.382a2.968 2.968 0 00-1.294-1.348c-.57-.31-1.191-.466-1.916-.466-.829 0-1.605.207-2.227.57-.621.415-1.139.933-1.45 1.658h3.729v1.348h-4.091c-.052.259-.052.518-.052.777 0 .26 0 .518.052.777h4.091v1.348h-3.729c.363.725.829 1.295 1.45 1.658.622.415 1.398.57 2.227.57.725 0 1.346-.155 1.916-.466zM123.689 162.933c.57-.311.984-.778 1.295-1.348h2.382c-.466 1.141-1.191 2.073-2.175 2.695-.984.622-2.123.933-3.418.933-1.346 0-2.589-.363-3.624-1.088-1.036-.726-1.813-1.71-2.227-2.954h-1.605v-1.348h1.294c0-.311-.052-.57-.052-.777 0-.207 0-.466.052-.777h-1.294v-1.348h1.605c.414-1.243 1.139-2.228 2.227-2.954 1.035-.725 2.278-1.088 3.624-1.088 1.295 0 2.434.311 3.418.933a5.348 5.348 0 012.175 2.695h-2.382a2.97 2.97 0 00-1.295-1.348c-.569-.311-1.191-.466-1.916-.466-.828 0-1.605.207-2.226.57-.622.415-1.14.933-1.45 1.658h3.728v1.348h-4.091c-.052.259-.052.518-.052.777s0 .518.052.777h4.091v1.348h-3.78c.362.725.828 1.295 1.45 1.658.621.415 1.398.57 2.226.57.777 0 1.399-.155 1.968-.466zM29.239 182.211c.57-.311.984-.777 1.294-1.347h2.383c-.466 1.14-1.191 2.073-2.175 2.695-.984.621-2.123.932-3.418.932-1.346 0-2.589-.362-3.625-1.088-1.035-.725-1.812-1.71-2.226-2.954h-1.606v-1.347h1.295c0-.311-.052-.57-.052-.778 0-.207 0-.466.052-.777h-1.295V176.2h1.606c.414-1.244 1.139-2.229 2.226-2.954 1.036-.726 2.279-1.089 3.625-1.089 1.295 0 2.434.311 3.418.933a5.345 5.345 0 012.175 2.695h-2.382a2.967 2.967 0 00-1.295-1.347c-.57-.311-1.191-.467-1.916-.467-.829 0-1.605.208-2.227.57-.621.415-1.139.933-1.45 1.659h3.729v1.347h-4.09c-.053.259-.053.518-.053.777 0 .26 0 .519.052.778h4.09v1.347h-3.727c.362.726.828 1.296 1.45 1.658.62.415 1.397.571 2.226.571.725 0 1.398-.156 1.916-.467z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "prefix__paint0_linear",
                        x1: 65.925,
                        y1: 263.022,
                        x2: 57.59,
                        y2: 268.557,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#343779"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.996,
                                stopColor: "#1C1B3E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "prefix__paint1_linear",
                        x1: 65.299,
                        y1: 262.08,
                        x2: 56.965,
                        y2: 267.615,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#343779"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.996,
                                stopColor: "#1C1B3E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "prefix__paint2_linear",
                        x1: 109.956,
                        y1: 263.812,
                        x2: 101.184,
                        y2: 268.623,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#343779"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.996,
                                stopColor: "#1C1B3E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "prefix__paint3_linear",
                        x1: 109.412,
                        y1: 262.82,
                        x2: 100.64,
                        y2: 267.631,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#343779"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.996,
                                stopColor: "#1C1B3E"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "prefix__paint4_linear",
                        x1: 74.487,
                        y1: 199.267,
                        x2: 43.605,
                        y2: 199.267,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#241134"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#572763"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "prefix__paint5_linear",
                        x1: 12.563,
                        y1: 211.423,
                        x2: 97.525,
                        y2: 196.104,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#241134"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.741,
                                stopColor: "#492156"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#572763"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "prefix__paint6_linear",
                        x1: 79.981,
                        y1: 17.118,
                        x2: 69.852,
                        y2: 197.616,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FDB836"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.996,
                                stopColor: "#EC5845"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "prefix__paint7_linear",
                        x1: 125.162,
                        y1: 19.654,
                        x2: 115.032,
                        y2: 200.151,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FDB836"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: 0.996,
                                stopColor: "#EC5845"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "prefix__clip0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(.5)",
                            d: "M0 0h247v270H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var svg_ValuePropositionOne = (ValuePropositionOne);

;// CONCATENATED MODULE: ./src/caterers/components/ClaimCatererProfileLargeCTA.js

function ClaimCatererProfileLargeCTA_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: ",
        ";\n  justify-content: space-between;\n  align-items: center;\n  padding: ",
        "px;\n  margin-top: ",
        "px;\n  margin-bottom: ",
        "px;\n  background: #f8f8f8;\n"
    ]);
    ClaimCatererProfileLargeCTA_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ClaimCatererProfileLargeCTA_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n"
    ]);
    ClaimCatererProfileLargeCTA_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ClaimCatererProfileLargeCTA_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: ",
        "px;\n"
    ]);
    ClaimCatererProfileLargeCTA_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ClaimCatererProfileLargeCTA_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  margin-left: ",
        "px;\n"
    ]);
    ClaimCatererProfileLargeCTA_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ClaimCatererProfileLargeCTA_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    ClaimCatererProfileLargeCTA_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ClaimCatererProfileLargeCTA_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n"
    ]);
    ClaimCatererProfileLargeCTA_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ClaimCatererProfileLargeCTA_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  margin-top: ",
        "px;\n"
    ]);
    ClaimCatererProfileLargeCTA_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n  margin-left: ",
        "px;\n  margin-right: ",
        "px;\n  width: ",
        "%;\n  height: ",
        "%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n  color: #7d8f5b;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: ",
        "px;\n  margin-top: ",
        "px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}








function ClaimCatererProfileLargeCTA(param) {
    var catererName = param.catererName, openClaimCatererProfileForm = param.openClaimCatererProfileForm;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var t = (0,useTranslation/* useTranslation */.$)("caterers").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClaimCatererProfileLargeCTA_StyledContainer, {
        mobile: mobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClaimCatererProfileLargeCTA_StyledLeftContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopLeftContainer, {
                        mobile: mobile,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ClaimCatererProfileLargeCTA_StyledCTATextContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCTATitle, {
                                        mobile: mobile,
                                        children: "".concat(t("caterer.customizeProfileCTAHeader")).concat(catererName, "?")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                        children: t("caterer.customizeProfileCTALabel")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBaseLeftContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseText, {
                                mobile: mobile,
                                children: t("caterer.customizeProfileDescription")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBaseText, {
                                mobile: mobile,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* Trans */.c, {
                                    t: t,
                                    i18nKey: "caterer.visitPartnerSite",
                                    components: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                            href: "/caterer"
                                        }, "link")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ClaimCatererProfileLargeCTA_StyledButton, {
                                onClick: openClaimCatererProfileForm,
                                outlined: true,
                                children: t("caterer.customizeProfileButton")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRightContainer, {
                mobile: mobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_ValuePropositionOne, {})
            })
        ]
    });
}
var ClaimCatererProfileLargeCTA_StyledContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileLargeCTA_templateObject(), function(props) {
    return props.mobile ? "column" : "row";
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(2);
});
var ClaimCatererProfileLargeCTA_StyledLeftContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileLargeCTA_templateObject1());
var StyledTopLeftContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileLargeCTA_templateObject2(), function(props) {
    return props.theme.spacing(props.mobile ? 2 : 0);
});
var ClaimCatererProfileLargeCTA_StyledCTATextContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileLargeCTA_templateObject3(), function(props) {
    return props.theme.spacing(2);
});
var StyledCTATitle = (0,styled_components_browser_esm["default"])(esm.Typography)(ClaimCatererProfileLargeCTA_templateObject4(), function(props) {
    return props.theme.typography[props.mobile ? "body1" : "subtitle1"];
}, function(props) {
    return props.theme.typography[props.mobile ? "h3" : "subtitle1"].fontWeight;
});
var StyledBaseLeftContainer = (0,styled_components_browser_esm["default"])(esm.Box)(ClaimCatererProfileLargeCTA_templateObject5());
var StyledBaseText = (0,styled_components_browser_esm["default"])(esm.Typography)(ClaimCatererProfileLargeCTA_templateObject6(), function(props) {
    return props.theme.typography[props.mobile ? "body1" : "subtitle2"].fontSize;
}, function(props) {
    return props.theme.spacing(2);
});
var StyledRightContainer = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject7(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.mobile ? 50 : 100;
}, function(props) {
    return props.mobile ? 50 : 100;
});
var StyledLink = (0,styled_components_browser_esm["default"])(Link/* default */.Z)(_templateObject8());
var ClaimCatererProfileLargeCTA_StyledButton = (0,styled_components_browser_esm["default"])(ScrollToTopButton/* default */.Z)(_templateObject9(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(2);
});
/* harmony default export */ var components_ClaimCatererProfileLargeCTA = (ClaimCatererProfileLargeCTA);

// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/TopCaterers/TopCaterersCard.js + 2 modules
var TopCaterersCard = __webpack_require__(97010);
;// CONCATENATED MODULE: ./src/caterers/components/SimilarCaterersFactory.js

function SimilarCaterersFactory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    SimilarCaterersFactory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SimilarCaterersFactory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: ",
        "px;\n"
    ]);
    SimilarCaterersFactory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var SimilarCaterersFactory = function(param) {
    var similarCaterers = param.similarCaterers, city = param.city;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("xs");
    });
    var t = (0,useTranslation/* useTranslation */.$)("caterers").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimilarCaterersFactory_StyledContainer, {
        mobile: mobile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                variant: "subtitle1",
                children: t("caterer.similarCaterersHeader", {
                    city: t("common:cities.".concat(city.toLowerCase()))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                container: true,
                spacing: 2,
                children: similarCaterers.map(function(caterer) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        item: true,
                        md: 4,
                        sm: 6,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopCaterersCard/* default */.Z, {
                            caterer: caterer,
                            city: city,
                            imageOnly: false
                        })
                    }, caterer.objectID);
                })
            })
        ]
    });
};
var SimilarCaterersFactory_StyledContainer = (0,styled_components_browser_esm["default"])(esm.Box)(SimilarCaterersFactory_templateObject(), function(props) {
    return props.theme.spacing(props.mobile ? 3 : 4);
}, function(props) {
    return props.theme.spacing(props.mobile ? 3 : 4);
});
var StyledTitle = (0,styled_components_browser_esm["default"])(esm.Typography)(SimilarCaterersFactory_templateObject1(), function(props) {
    return props.theme.spacing(3);
});
/* harmony default export */ var components_SimilarCaterersFactory = (SimilarCaterersFactory);

// EXTERNAL MODULE: ./src/shared/layouts/MainLayout.tsx + 1 modules
var MainLayout = __webpack_require__(89452);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/pages/caterers/[city]/[caterer].js











var DEFAULT_CITY = "berlin";
function Caterer(param) {
    var ratings = param.ratings, unsignedCaterer = param.unsignedCaterer, similarCaterers = param.similarCaterers, cityFromSlug = param.cityFromSlug;
    var ref = (0,react.useState)(false), isClaimCatererProfileFormOpened = ref[0], setIsClaimCatererProfileFormOpened = ref[1];
    var openClaimCatererProfileForm = function() {
        return setIsClaimCatererProfileFormOpened(true);
    };
    var closeClaimCatererProfileForm = function() {
        return setIsClaimCatererProfileFormOpened(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, {
        ratings: ratings,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CatererHeader, {
                    caterer: unsignedCaterer.fields
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClaimCatererProfileCTA, {
                    openClaimCatererProfileForm: openClaimCatererProfileForm,
                    catererName: unsignedCaterer.fields.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BookCateringCTAContainer, {
                    citySlug: cityFromSlug,
                    catererName: unsignedCaterer.fields.name,
                    unsignedCatererAddress: "".concat(unsignedCaterer.fields.address.street, ", ").concat(unsignedCaterer.fields.address.city),
                    deliverySchedule: unsignedCaterer.fields.workingHours
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClaimCatererProfileLargeCTA, {
                    catererName: unsignedCaterer.fields.name,
                    openClaimCatererProfileForm: openClaimCatererProfileForm
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SimilarCaterersFactory, {
                    city: cityFromSlug || DEFAULT_CITY,
                    similarCaterers: similarCaterers
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClaimCatererProfileForm, {
                    unsignedCaterer: unsignedCaterer.fields,
                    isClaimCatererProfileFormOpened: isClaimCatererProfileFormOpened,
                    closeClaimCatererProfileForm: closeClaimCatererProfileForm
                })
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ var _caterer_ = (Caterer);


/***/ }),

/***/ 21890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  pointer-events: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  z-index: -1;\n  pointer-events: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var BackgroundImage = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBackgroundImage, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            alt: ""
        }, props))
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject());
var StyledBackgroundImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])((next_image__WEBPACK_IMPORTED_MODULE_3___default()))(_templateObject1());
/* harmony default export */ __webpack_exports__["Z"] = (BackgroundImage);


/***/ }),

/***/ 3317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_FormikFormField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
;// CONCATENATED MODULE: ./src/shared/hooks/useFormikFormField.js


function useFormikFormField(param) {
    var field = param.field, _form = param.form, errors = _form.errors, touched = _form.touched, helperText = param.helperText;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var fieldError = (0,formik_esm/* getIn */.u9)(errors, field.name);
    var showError = (0,formik_esm/* getIn */.u9)(touched, field.name) && !!fieldError;
    var formHelperText = showError && t(fieldError) || helperText;
    return {
        showError: showError,
        formHelperText: formHelperText
    };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 12 modules
var TextField = __webpack_require__(77269);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./src/system/components/Textarea.js


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  .MuiFilledInput-root {\n    border-radius: 8px;\n    padding: 12px;\n    background-color: ",
        ";\n    border: 1px solid transparent;\n    line-height: ",
        ";\n\n    &:hover {\n      background-color: ",
        ";\n      border: 1px solid ",
        ";\n    }\n\n    &:active,\n    &:focus,\n    &:focus-visible,\n    &.Mui-focused {\n      border: 1px solid ",
        ";\n    }\n  }\n\n  .MuiFilledInput-underline:before {\n    border-bottom: none;\n  }\n  .MuiFilledInput-underline:after {\n    border-bottom: none;\n  }\n\n  .MuiInputBase-inputMultiline {\n    cursor: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Textarea = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextarea, (0,_object_spread/* default */.Z)({
        ref: ref,
        multiline: true,
        rows: 4,
        variant: "filled"
    }, props));
});
Textarea.displayName = "Textarea";
var StyledTextarea = (0,styled_components_browser_esm["default"])(TextField/* default */.Z)(_templateObject(), function(props) {
    return props.theme.palette.text.disabled;
}, function(props) {
    return props.theme.typography.body1.lineHeight;
}, function(props) {
    return props.theme.palette.text.disabled;
}, function(props) {
    return props.theme.palette.grey[400];
}, function(props) {
    return props.theme.palette.grey[600];
});
/* harmony default export */ var components_Textarea = (Textarea);

;// CONCATENATED MODULE: ./src/shared/components/FormikFormField.js







function FormikFormField(param) {
    var field = param.field, form = param.form, helperText = param.helperText, _label = param.label, label = _label === void 0 ? "" : _label, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _required = param.required, required = _required === void 0 ? false : _required, _type = param.type, type = _type === void 0 ? "text" : _type, _autocomplete = param.autocomplete, autocomplete = _autocomplete === void 0 ? "off" : _autocomplete, _multiline = param.multiline, multiline = _multiline === void 0 ? false : _multiline, inputRef = param.inputRef;
    var ref = useFormikFormField({
        field: field,
        form: form,
        helperText: helperText
    }), formHelperText = ref.formHelperText, showError = ref.showError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.FormControl, {
        error: showError,
        required: required,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.InputLabel, {
                htmlFor: field.name,
                children: label
            }),
            multiline ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Textarea, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                autoComplete: autocomplete,
                placeholder: placeholder,
                ref: inputRef
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                type: type,
                autoComplete: autocomplete,
                placeholder: placeholder,
                ref: inputRef
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.FormHelperText, {
                children: formHelperText
            })
        ]
    });
}
/* harmony default export */ var components_FormikFormField = (FormikFormField);


/***/ }),

/***/ 20486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      pointer-events: none;\n      color: ",
        ";\n      cursor: default;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  text-decoration: none;\n  border-radius: 4px;\n  padding: ",
        ";\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: ",
        ";\n  margin: 0 4px;\n\n  &:hover {\n    background-color: ",
        ";\n    color: black;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function Locale() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("nav", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "sr-only",
                children: "Language switcher"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: router.asPath,
                passHref: true,
                locale: "de",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ToggleButton, {
                    selected: router.locale === "de",
                    children: "DE"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: router.asPath,
                passHref: true,
                locale: "en",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ToggleButton, {
                    selected: router.locale === "en",
                    children: "EN"
                })
            })
        ]
    });
}
var ToggleButton = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].a(_templateObject1(), function(props) {
    return props.theme.spacing(1, 1);
}, function(props) {
    return props.theme.palette.grey[600];
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.selected && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), function(props) {
        return props.theme.palette.common.white;
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Locale);


/***/ }),

/***/ 42124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);







function ScrollToTopButton(_param) {
    var children = _param.children, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__.Button, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        onClick: function() {
            return window.scroll({
                top: 0,
                behavior: "smooth"
            });
        },
        size: "lg",
        rounded: true
    }, restProps), {
        children: children
    }));
}
ScrollToTopButton.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_6___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_6___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_6___default().node)),
        (prop_types__WEBPACK_IMPORTED_MODULE_6___default().node), 
    ]).isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrollToTopButton);


/***/ }),

/***/ 4285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ legalEntityName; }
/* harmony export */ });
var DEFAULT_LEGAL_ENTITY = "Hey Group GmbH";
var LEGAL_ENTITY_BY_LOCALE = {
    "en-uk": "HEYCATER! UK LTD"
};
function legalEntityName(locale) {
    return locale && LEGAL_ENTITY_BY_LOCALE[locale.toLowerCase()] || DEFAULT_LEGAL_ENTITY;
}


/***/ }),

/***/ 53279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ attributeNameForLocale; },
/* harmony export */   "u": function() { return /* binding */ algoliaAttributeNameForLocale; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48403);
/* harmony import */ var lodash_capitalize__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_capitalize__WEBPACK_IMPORTED_MODULE_0__);


var localeConfig = {
    locales: [
        "en",
        "de"
    ],
    defaultLocale: "de"
};
var algoliaAttributeNameForLocale = function(locale) {
    return function(name) {
        var toLocalizedAlgoliaKey = function(name) {
            var parsedLocale = localeConfig.locales.includes(locale) ? locale : localeConfig.defaultLocale;
            return "".concat(name, "_").concat(parsedLocale);
        };
        if (name.includes(".")) {
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(name.split("."), 2), scope = ref[0], fieldName = ref[1];
            // @ts-expect-error: edge case, hard to type
            return "".concat(scope, ".").concat(toLocalizedAlgoliaKey(fieldName));
        }
        return toLocalizedAlgoliaKey(name);
    };
};
var attributeNameForLocale = function(locale) {
    return function(name) {
        if (!localeConfig.locales.includes(locale)) return "".concat(name).concat(lodash_capitalize__WEBPACK_IMPORTED_MODULE_0___default()(localeConfig.defaultLocale));
        return "".concat(name).concat(lodash_capitalize__WEBPACK_IMPORTED_MODULE_0___default()(locale));
    };
};


/***/ }),

/***/ 11162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useCurrencySymbol; }
/* harmony export */ });
/* harmony import */ var shared_hooks_useIsGb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9858);

var useCurrencySymbol = function() {
    var isGb = (0,shared_hooks_useIsGb__WEBPACK_IMPORTED_MODULE_0__/* .useIsGb */ .y)();
    return isGb ? "\xa3" : "€";
};


/***/ }),

/***/ 9858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useIsGb; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var useIsGb = function() {
    var slug = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().query.slug;
    return slug === "catering-london";
};


/***/ }),

/***/ 25734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocalizedFieldName; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var shared_helpers_localizedFieldNames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53279);


function useLocalizedFieldName() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var localizedFieldAlgolia = (0,shared_helpers_localizedFieldNames__WEBPACK_IMPORTED_MODULE_1__/* .algoliaAttributeNameForLocale */ .u)(router.locale);
    var localizedAttributeName = (0,shared_helpers_localizedFieldNames__WEBPACK_IMPORTED_MODULE_1__/* .attributeNameForLocale */ .q)(router.locale);
    return {
        localizedFieldAlgolia: localizedFieldAlgolia,
        localizedAttributeName: localizedAttributeName
    };
}


/***/ }),

/***/ 89452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ PageLayout; },
  "Z": function() { return /* binding */ layouts_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Facebook.js
var Facebook = __webpack_require__(83792);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LinkedIn.js
var LinkedIn = __webpack_require__(20551);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Twitter.js
var Twitter = __webpack_require__(44704);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/shared/components/CookieContextProvider.tsx + 1 modules
var CookieContextProvider = __webpack_require__(82293);
// EXTERNAL MODULE: ./src/shared/components/Locale.js
var Locale = __webpack_require__(20486);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/helpers/legalEntity.ts
var legalEntity = __webpack_require__(4285);
// EXTERNAL MODULE: ./src/shared/svg/Logo.js
var Logo = __webpack_require__(37582);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/layouts/Footer.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  display: flex;\n  align-items: start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: inherit;\n  border: inherit;\n  line-height: 23px;\n  height: inherit;\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  cursor: pointer;\n  display: inline-block;\n\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: ",
        ";\n  color: white;\n  border: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: ",
        ";\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  display: flex;\n\n  ",
        " {\n    margin: ",
        ";\n    display: flex;\n    text-decoration: none;\n    list-style: none;\n    padding: 0;\n    flex-direction: ",
        ";\n    align-items: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  display: inline-block;\n  cursor: pointer;\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  cursor: pointer;\n  margin: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #9cba6c;\n  text-decoration: none;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
















var YEAR = new Date().getFullYear();
function Footer() {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref = (0,react.useContext)(CookieContextProvider/* CookieContext */.U), detailsOpen = ref.detailsOpen, setDetailsOpen = ref.setDetailsOpen;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
            className: "main-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                    alt: "",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                fontSize: 12,
                                color: "white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Locale/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                                as: "nav",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "sr-only",
                                        children: "Social Links"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.linkedin.com/company/heycater/",
                                        "aria-label": "Linkedin",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.facebook.com/heycater",
                                        "aria-label": "Facebook",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://twitter.com/HeyHeycater",
                                        "aria-label": "Twitter",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, {
                        flexDirection: "column",
                        as: "nav",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                            mobileColumn: true,
                            as: "ul",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/impressum",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.imprint")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/agb",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.terms")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/datenschutz",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.privacy")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                        as: "button",
                                        onClick: function() {
                                            return setDetailsOpen(!detailsOpen);
                                        },
                                        children: "Cookies"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: constants/* LINKS.career */.BA.career,
                                        rel: "noopener",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerLink, {
                                            target: "_blank",
                                            children: t("common:navigation.career")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/about-us",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: "About us"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/hub",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.blog")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/partner-page",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterLink, {
                                            children: [
                                                "\uD83E\uDDD1‍\uD83C\uDF73 ",
                                                t("common:navigation.partner")
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTypography, {
                        pt: 2,
                        fontSize: 12,
                        children: [
                            YEAR,
                            " ",
                            (0,legalEntity/* legalEntityName */.t)(locale)
                        ]
                    })
                ]
            })
        })
    });
}
var NavListItem = styled_components_browser_esm["default"].li(_templateObject());
var StyledLink = styled_components_browser_esm["default"].a(_templateObject1(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var StyledFooter = styled_components_browser_esm["default"].div(_templateObject2(), function(props) {
    return props.theme.spacing(4, 0);
}, function(props) {
    return props.theme.palette.text.primary;
});
var FooterWrapper = styled_components_browser_esm["default"].div(_templateObject3(), function(props) {
    return props.flexDirection;
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var FooterColumn = styled_components_browser_esm["default"].div(_templateObject4(), function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(1, 0);
}, function(props) {
    return props.mobileColumn ? "column" : "row";
});
var FooterLink = styled_components_browser_esm["default"].a(_templateObject5(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var FooterSocialIconLink = styled_components_browser_esm["default"].a(_templateObject6(), function(props) {
    return props.theme.spacing(0, 1.75);
});
var StyledTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject7(), function(props) {
    return props.theme.palette.grey[400];
});
var CareerLink = (0,styled_components_browser_esm["default"])(FooterLink)(_templateObject8());
/* harmony default export */ var layouts_Footer = (Footer);

// EXTERNAL MODULE: ./src/shared/layouts/Navigation.tsx + 2 modules
var Navigation = __webpack_require__(48107);
;// CONCATENATED MODULE: ./src/shared/layouts/MainLayout.tsx






function MainLayout(param) {
    var children = param.children, _hideNavigationLinks = param.hideNavigationLinks, hideNavigationLinks = _hideNavigationLinks === void 0 ? false : _hideNavigationLinks, _hideNavbar = param.hideNavbar, hideNavbar = _hideNavbar === void 0 ? false : _hideNavbar, renderNavbarCta = param.renderNavbarCta, ratings = param.ratings;
    if (hideNavbar) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
            main: children,
            footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_Footer, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* default */.Z, {
            ratings: ratings,
            hideNavigationLinks: hideNavigationLinks,
            renderCTA: renderNavbarCta
        }),
        main: children,
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_Footer, {})
    });
}
MainLayout.propTypes = {
    children: prop_types_default().oneOfType([
        prop_types_default().arrayOf((prop_types_default()).node),
        (prop_types_default()).node, 
    ]).isRequired
};
var PageLayout = function(param) {
    var header = param.header, main = param.main, footer = param.footer, root = param.root;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        position: "sticky",
                        top: "0",
                        zIndex: "100",
                        style: {
                            background: "white"
                        },
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        as: "main",
                        display: "flex",
                        overflow: "clip",
                        flexDirection: "column",
                        flexGrow: "1",
                        children: main
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        as: "footer",
                        mt: "auto",
                        children: footer
                    })
                ]
            }),
            root
        ]
    });
};
/* harmony default export */ var layouts_MainLayout = (MainLayout);


/***/ }),

/***/ 91902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ webToLeadRequest; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./src/lib/bugsnag.js
var bugsnag = __webpack_require__(45817);
;// CONCATENATED MODULE: ./src/shared/helpers/fetchWithRetry.js


var fetchWithRetry = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(url, options) {
        var retry, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retry = options && options.retry || 3;
                    _state.label = 1;
                case 1:
                    if (!(retry > 0)) return [
                        3,
                        8
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        7
                    ]);
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    e = _state.sent();
                    if (options && options.callback) {
                        options.callback(retry);
                    }
                    retry = retry - 1;
                    if (retry === 0) {
                        throw e;
                    }
                    if (!(options && options.pause)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        sleep(options.pause)
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        3,
                        1
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchWithRetry(url, options) {
        return _ref.apply(this, arguments);
    };
}();
function sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}

;// CONCATENATED MODULE: ./src/shared/services/webToLeadRequest.js





function webToLeadRequest() {
    return _webToLeadRequest.apply(this, arguments);
}
function _webToLeadRequest() {
    _webToLeadRequest = (0,_async_to_generator/* default */.Z)(function() {
        var payload, webToLeadData, body, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            payload = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, webToLeadData = _arguments.length > 1 ? _arguments[1] : void 0;
            body = query_string.stringify(webToLeadData(payload));
            response = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function() {
                    var error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    fetchWithRetry("https://heycater.my.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8", {
                                        method: "POST",
                                        mode: "no-cors",
                                        headers: {
                                            "Content-Type": "application/x-www-form-urlencoded"
                                        },
                                        body: body,
                                        retry: 2,
                                        pause: 1500
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                bugsnag/* default.notify */.Z.notify(new Error("[Error trying to submit Salesforce webToLeadRequest:\n            dataFromFunnel: ".concat(JSON.stringify(payload), "\n            webToLeadData: ").concat(JSON.stringify(body), "\n            error: ").concat(JSON.stringify(error))));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function response() {
                    return _ref.apply(this, arguments);
                };
            }();
            return [
                2,
                response()
            ];
        });
    });
    return _webToLeadRequest.apply(this, arguments);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,4658,5675,2311,7766,8184,2580,7269,9695,8077,8107,7010,9774,2888,179], function() { return __webpack_exec__(19573); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);